import { render } from "./FormInputWrap.vue?vue&type=template&id=f63464b6"
import script from "./FormInputWrap.vue?vue&type=script&lang=js"
export * from "./FormInputWrap.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__